'use strict';

var React = require('react');
var classNames = require('classnames');
var index = require('../ImageCardHorizontal/index.js');
var index$1 = require('../TextCard/index.js');
require('../../assets/BrandFandomLogomark');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

const getLinesClampCount = ({ shape, subtext, numberOfTitleLinesToShow, isNarrow, shouldPreferSubtextOverTitle, }) => {
    // squared cards
    if (shape === 'square' && isNarrow) {
        return shouldPreferSubtextOverTitle ? { title: 1, subtext: 2 } : { title: 2, subtext: 1 };
    }
    if (shape === 'square') {
        return subtext ? { title: 1, subtext: 1 } : { title: 2, subtext: 1 };
    }
    // rounded card
    if (subtext) {
        return numberOfTitleLinesToShow === 1 ? { title: 1, subtext: 2 } : { title: 2, subtext: 1 };
    }
    return { title: numberOfTitleLinesToShow };
};
const CardHorizontal = ({ numberOfTitleLinesToShow = 1, hasImgLink = true, imageCardProps, textCardProps, isNarrow, shouldPreferSubtextOverTitle = false, }) => {
    const { shape } = imageCardProps;
    const { subtext } = textCardProps;
    const cardClasses = classNames__default["default"]('card-horizontal', {
        'card-horizontal--round': shape === 'round',
        'card-horizontal--square': shape === 'square',
        'card-horizontal--narrow': isNarrow,
    });
    const imageContainerClass = classNames__default["default"]('card-horizontal__image-container', {
        'card-horizontal__image-container--hoverable': hasImgLink && textCardProps.titleLink,
        'card-horizontal__image-container--hoverable-rounded': hasImgLink && textCardProps.titleLink && imageCardProps.shape === 'round',
    });
    const linesClampCount = getLinesClampCount({
        shape,
        subtext: subtext,
        numberOfTitleLinesToShow,
        isNarrow,
        shouldPreferSubtextOverTitle,
    });
    return (React__default["default"].createElement("div", { className: cardClasses },
        hasImgLink && textCardProps.titleLink ? (React__default["default"].createElement("a", { className: imageContainerClass, href: textCardProps.titleLink, onClick: () => { var _a; return (_a = textCardProps.onTitleClick) === null || _a === void 0 ? void 0 : _a.call(textCardProps); } },
            React__default["default"].createElement(index, Object.assign({}, imageCardProps)))) : (React__default["default"].createElement("div", { className: "card-horizontal__image-container" },
            React__default["default"].createElement(index, Object.assign({}, imageCardProps)))),
        React__default["default"].createElement(index$1, Object.assign({}, textCardProps, { isHorizontal: true, numberOfLinesToTruncateTitle: linesClampCount.title, numberOfLinesToTruncateSubtext: linesClampCount.subtext }))));
};

module.exports = CardHorizontal;
